import React from 'react';
import styled from 'astroturf/react';
import { BodyLink } from 'js/design_system/link/BodyLink';
import { currentUser } from 'js/utils/user';
import { ImpressionWatcher } from 'js/utils/impressions/ImpressionWatcher';

const Container = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Header = styled.div`
  display: flex;
  padding-bottom: 12px;
`;

const ViewMoreButton = styled(BodyLink)`
  height: auto !important;
  color: $ds-gray-dark;
  font-size: 12px;

  &:not(:hover) {
    text-decoration: none;
  }
`;

const Title = styled(BodyLink)`
  flex-grow: 1;
  color: $ds-black;
`;

type Props = {
  viewAllUrl?: string;
  headerText: string;
  className?: string;
  impressionSource: string;
};

const SuggestedContentSidebar: React.FC<React.PropsWithChildren<Props>> = ({
  viewAllUrl,
  headerText,
  className,
  impressionSource,
  children,
}) => (
  <div className={className}>
    <Header>
      <Title bold>{headerText}</Title>
      {currentUser && viewAllUrl && (
        <ImpressionWatcher active={true} source={impressionSource}>
          <ViewMoreButton href={viewAllUrl}>View all</ViewMoreButton>
        </ImpressionWatcher>
      )}
    </Header>
    <Container>{children}</Container>
  </div>
);

export default SuggestedContentSidebar;
